import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { GetSelected } from "../../../../common/tableHandler/manipulateTable";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) oTable.fnClearTable();
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        const maatregeCircleType =
          data.content["maatregel-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">beheerobject heeft een maatregel</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">beheerobject heeft geen maatregel</span></div>';
        const planningCircleType =
          data.content["status-globaleplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">beheerobject heeft een globale planning.</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">beheerobject heeft geen globale planning.</span></div>';
        const algemeenGisratioid =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-gisratio"] +
          "</span>";
        const maatregelNaam =
          '<a href="javascript:void(0)">' +
          data.content["maatregel-naam"] +
          "</a>";
        const planningspatroonData = data.content["planningspatroon-naam"]
          ? data.content["planningspatroon-naam"]
          : "";
        const planningsperiodeNaam = data.content["planningsperiode-naam"]
          ? data.content["planningsperiode-naam"]
          : "";
        const discipline = data.content["discipline-naam"]
            ? data.content["discipline-naam"]
            : "";
        const planningspatroon =
          '<span class="text-dark font-weight-bold">' +
          planningspatroonData +
          "</span>";
        const checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        const model = {
          algemeenGisratioid: data.content["algemeen-gisratio"],
          maatregelNaam: data.content["maatregel-naam"],
          planningspatroon: planningspatroonData,
          identification: data.identification,
        };

        var test = {
          checkbox: checkbox,
          measures: maatregeCircleType,
          measures_plannig: planningCircleType,
          "Gisratio ID": algemeenGisratioid,
          Maatregel: maatregelNaam,
          Planningspatroon: planningspatroon,
          Planningsperiode: planningsperiodeNaam,
          "Discipline": discipline,
        };

        let _columnList = [];
        if (columnList && columnList.column_list){
          for (let column in columnList.column_list) {
            for (let key in test) {
              if (
                  columnList.column_list[column].toLowerCase() === key.toLowerCase()
              ) {
                _columnList.push(test[key]);
              }
            }
          }
        }

        window.$mm_measures_Glist.push(model);
        const addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // maatregeCircleType,
            // planningCircleType,
            // algemeenGisratioid,
            // maatregelNaam,
            // discipline
            // planningspatroon,
            // planningsperiodeNaam,
          ],
          false
        );

        const theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#total-rows").html(result.meta.total_found);
  window.$mm_measures_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$mm_measures_gvv = 0;
  window.$mm_measures_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-gisratio") {
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_algemeenGisratioid.push(data);
    });
  } else if (data.id === "maatregel-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_maatregelNaam.push(data);
    });
  } else if (data.id === "planningspatroon-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_planningspatroonNaam.push(data);
    });
  } else if (data.id === "planningsperiode-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_planningsperiodeNaam.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-gisratio") {
    window.$mm_measures_algemeenGisratioid.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_algemeenGisratioid.push(data);
    });
  } else if (searchId === "maatregel-naam") {
    window.$mm_measures_maatregelNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_maatregelNaam.push(data);
    });
  } else if (searchId === "planningspatroon-naam") {
    window.$mm_measures_planningspatroonNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_planningspatroonNaam.push(data);
    });
  } else if (searchId === "planningsperiode-naam") {
    window.$mm_measures_planningsperiodeNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_measures_planningsperiodeNaam.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {};

export const BeheereenheidEditCallBack = (token) => {};

export const RowsDeletedCallBack = (token) => {};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  // var actionsOfDisabled = [];
  // $.each(result.data.stages, function (index, stage) {
  //   if (stage.definition.type === "activity" && stage.start_allowed === true) {
  //     actionsOfSelection.push(stage.definition.identification);
  //   } else {
  //     actionsOfDisabled.push(stage.definition);
  //   }
  // });

  $("#myPopup").html("");
  if(GetSelected().length > 0){
    $.each(window.$mm_measures_actions, function (index, action) {
      if ($.inArray(action["id"], result) !== -1) {
        var anchor = $("<a></a>")
            .attr({ role: "button", id: action["id"] })
            .addClass(action["class"] + " mm-measures-action")
            .html(action["text"]);
        $("#myPopup").append(anchor);
      }
    });
  }

  /* window.$mm_measures_actions.forEach((action) => {
    if (actionsOfSelection.indexOf(action["id"]) !== -1) {
      var anchor = $("<a></a>")
        .attr({ role: "button", id: action["id"] })
        .addClass(action["class"] + " mm-measures-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    } else if (action["text"] === "Plaats in Globale planning") {
      var anchor = $("<a disabled></a>")
        .attr({ role: "button", id: action["identification"] })
        .addClass("disabled" + " mm-measures-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  }); */

  // $.each(window.$mm_measures_actions, function (index, action) {
  //   if ($.inArray(action["id"], actionsOfSelection) !== -1) {
  //     var anchor = $("<a></a>")
  //       .attr({ role: "button", id: action["id"] })
  //       .addClass(action["class"] + " mm-measures-action")
  //       .html(action["text"]);
  //     $("#myPopup").append(anchor);
  //   }
  // });
  //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });
  var toonOpKaart = $("<a></a>")
    .attr({ role: "button", id: "measures_toon_dossiers_op_kaart" })
    .addClass("locate mm-measures-action")
    .html("Toon op kaart");
  $("#myPopup").append(toonOpKaart);

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const WorkResourcesCallBack = (result) => {
  $("#koppelen-werkbron-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="werk-resource"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#koppelen-werkbron-grp").append(btn);
  });
};

export const GrpCallBack = (divId, nameId, result, pageNumber) => {
  if (pageNumber == 0) {
    $("#" + divId).html("");
  }
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="' +
      nameId +
      '"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#" + divId).append(btn);
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var maatregelenIndex = test_list.findIndex((x) =>
    x.includes("maatregelen-svg")
  );
  test_list[maatregelenIndex] = "measures";
  var plannigIndex = test_list.findIndex((x) => x.includes("plannig-svg"));
  test_list[plannigIndex] = "measures_plannig";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "management-maintenance>measures",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "management-maintenance>measures"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
